/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerAppNotification as ModelsCustomerCustomerAppNotification } from '../../models/Models/Customer/customer-app-notification';

export interface V3CustomersAdminAppNotificationsPost$Json$Params {
      body?: ModelsCustomerCustomerAppNotification
}

export function v3CustomersAdminAppNotificationsPost$Json(http: HttpClient, rootUrl: string, params?: V3CustomersAdminAppNotificationsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersAdminAppNotificationsPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

v3CustomersAdminAppNotificationsPost$Json.PATH = '/v3/customers-admin/app-notifications';
